<template>
  <b-card title="Add Category Accesories">
    <b-col cols="12">
      <b-row class="mb-2">
        <b-col cols="4">
          <b-button variant="primary" :to="{ name: 'accessories-category' }">
            Back to Category Accesories
          </b-button>
        </b-col>
      </b-row>
      <b-row>
        <b-col cols="12">
          <validation-observer ref="addCategory">
            <b-form-group>
              <span>Name <span style="color:red">(*)</span></span>
              <validation-provider
                v-slot="{ errors }"
                name="Name"
                rules="required"
              >
                <b-form-input
                  v-model="dataForm.name"
                  type="text"
                  placeholder="Name"
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                ></b-form-input>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group>
              <span>Description <span style="color:red">(*)</span></span>
              <validation-provider
                v-slot="{ errors }"
                name="Description"
                rules="required"
              >
                <b-form-textarea
                  v-model="dataForm.description"
                  type="text"
                  placeholder="Description""
                  :state="errors.length > 0 ? false : null"
                  style="margin-top:5px !important;"
                ></b-form-textarea>
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

          </validation-observer>
        </b-col>
        <b-col cols="12">
          <b-button variant="success" @click="addData"> Save </b-button
          >
        </b-col>
      </b-row>
    </b-col>
  </b-card>
</template>

<script>
import { mapActions } from "vuex";
import { required} from "@validations";
import { ValidationProvider, ValidationObserver } from "vee-validate";
export default {
  components: {
    "validation-observer": ValidationObserver,
    "validation-provider": ValidationProvider,
  },
  props: ["id"],
  data() {
    return {
      dataForm: {
        name: '',
        description: ''
      }
    };
  },
  methods: {
    addData() {
      let payload = this.dataForm
      
      this.$refs.addCategory.validate().then((result) => {
        if (result) {
          this.addCategory(payload)
          .then(async (res) => {
            this.$bvToast.toast(
              `Successfully add data`,
              {
                title: "Success",
                variant: "success",
                solid: true,
              }
            );

            this.$router.go(-1);
          })
          .catch((e) => {
            console.log({ e });
            this.$bvToast.toast(
              `You have failed to create data`,
              {
                title: "Failed",
                variant: "danger",
                solid: true,
              }
            );
          });
        }
      });
    },
    ...mapActions({
      addCategory: "category/AddCategoriesAccessories"
    })
  },
  computed: {
  },
  mounted() {
  },
  created() {
    document.title = "Add Category Accessories | RSP";
  },
};
</script>